import React from "react";
import Card from "react-bootstrap/Card";
import { ImSvg } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi, I am <span className="purple">Nick Tarkovskiy </span>
            from <span className="purple"> Dnipro, Ukraine.</span>
            <br />
            I'm not currently employed.
            <br />
            I have completed ITStep middle-school in Dnipro and have been studying in Ukraine-American Lyceum (UAL).
            <br />
            <br />
            Besides coding, there are other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImSvg /> Go for a walk
            </li>
            <li className="about-activity">
              <ImSvg /> Listen to music
            </li>
            <li className="about-activity">
              <ImSvg /> Playing computer games
            </li>
          </ul>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
